





















































































import { Component, Vue, Provide, Watch } from "vue-property-decorator";
import automatiCall from "./components/automatiCall.vue";
const Overdue = () => import("./components/overdue.vue");
const Table = () => import("@/components/table.vue");
const AutoCall = () => import("./components/autoCall.vue");
const RepaymentPlan = () => import("./components/repaymentPlan.vue");
const RobotCallRecord = () => import("./components/robotCallRecord.vue");
const PaymentRecord = () => import("./components/paymentRecord.vue");
import { timeFormat } from "@/utils";
import {
  GetOverdueCaseReq,
  GetRemindCaseReq,
} from "@/pbjs/xcommon/collection_pb.js";
import { collectionServiceClient } from "@/api";
import { setCommon, errorMsg } from "@/utils/request";
import { Options, CaseLogOptions } from "@/request/getAllAutoCallResult";
@Component({
  name: "orderDeal",
  components: {
    Overdue,
    Table,
    RepaymentPlan,
    AutoCall,
    automatiCall,
    RobotCallRecord,
    PaymentRecord,
  },
})
export default class CombinationProperty extends Vue {
  @Provide() private supplieOptions: any = [];
  @Provide() private pageType: any = "";
  @Provide() private activeName: string = "";
  @Provide() private tableData: any = [{ opUid: 123, phoneObject: 22 }];
  @Provide() private autoCallData: any = [];
  @Provide() private robotcalloutrecorditemList: any = [];
  @Provide() private repayplanstagetablistList: any = []; //多订单还款计划
  @Provide() private paymentRecordList: any = []; // 回款记录 table 列表
  @Provide() private isdial: any;
  @Provide() private labelData: any = [
    { label: "ticket.Reminder", value: "opname" },
    { label: "ticket.CallObject", value: "phoneobject" },
    { label: "ticket.CollectionMethod", value: "urgetype" },
    { label: "ticket.ContactNumber", value: "phoneobjectmobile" },
    { label: "ticket.PhoneCallTime", value: "phonetime" },
    { label: "ticket.ResponseTime", value: "answertimestamp" },
    { label: "ticket.EndTime", value: "endtimestamp" },
    { label: "ticket.OnhookDirection", value: "hangupdirection" },
    { label: "ticket.ReasonForHangingUp", value: "hangupcause" },
    { label: "ticket.WhetherToDial", value: "phoneconnect" },
    { label: "ticket.CommitmentRepaymentTime", value: "promiserepaytime" },
    {
      label: "dashbordDy.Promisedrepaymentamount",
      value: "promiserepayamount",
    },
    { label: "ticket.ReasonForNotReturning", value: "overduereason" },
    { label: "ticket.WillingnessToRepay", value: "repayinclination" },
    { label: "ticket.ReasonForNotConnecting", value: "unconnectreason" },
    { label: "ticket.Result", value: "result" },
    { label: "tableLgy.CallMode", value: "dialway" },
    { label: "ticket.Recording", value: "remark" },
  ];
  @Provide() private autoCallLabelData: any = [
    { label: "Dialer.creationTime", value: "result.callcreatetime" }, //任务创建时间
    { label: "Dialer.outboundTime", value: "result.callstarttime" }, //实际外呼时间
    { label: "Dialer.explicitNumber", value: "result.showmobile" }, //外显号码
    { label: "Dialer.talkTime", value: "result.duration" }, // 通话时长
    { label: "ticket.isNotConnect", value: "result.isdial" }, //是否拨通
  ];
  @Provide() private robotCallLabelData: any = [
    { label: "Dialer.outboundTime", value: "callouttime" }, //  外呼时间
    { label: "ticket.WhetherToDial", value: "isdial" }, //  是否拨通
    { label: "Dialer.Thelabelofintent", value: "intentionlabel" }, //  意向标签
    { label: "Dialer.Callrecorddetails", value: "dialoguetext" }, // 接通对话内容 Callrecorddetails
    { label: "Dialer.Callrecorddetails", value: "逾期天数" }, // 接通对话内容 Callrecorddetails
    { label: "Dialer.Callrecorddetails", value: "供应商" }, // 接通对话内容 Callrecorddetails
    { label: "Dialer.Callrecorddetails", value: "未接通原因" }, // 接通对话内容 Callrecorddetails
    { label: "Dialer.Callrecorddetails", value: "挂机类型" }, // 接通对话内容 Callrecorddetails
    { label: "Dialer.Callrecorddetails", value: "处理建议" }, // 接通对话内容 Callrecorddetails
    { label: "详情", value: "详情" }, // 接通对话内容 Callrecorddetails
  ];
  @Provide() private repaymentPlanData: any = [];
  @Provide() private repayplanstageList: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private changePageCount: any = 0;
  @Provide() private repayplanstab: any = 0; //多订单tab
  @Provide() private urgebase: any; // 工单详情依赖的数据
  @Provide() private mobileNum: string = ""; //  获取自动外呼所需的参数
  @Provide() private caseId: number = 0;
  @Provide() private itemId: number = 0;
  @Provide() private orderId: string = "";
  @Provide() private suppliertypeList: any = [];
  @Provide() private multi_loan_switch: boolean = false;
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示

  private created() {
    let systemInfoAll: any = localStorage.getItem("systemInfoAll");
    JSON.parse(systemInfoAll);
    if (
      JSON.parse(systemInfoAll) &&
      JSON.parse(systemInfoAll).co &&
      JSON.parse(systemInfoAll).co.multi_loan_switch
    ) {
      this.multi_loan_switch = JSON.parse(systemInfoAll).co.multi_loan_switch;
    }
    if (this.$route.query.type == "overdue") {
      this.getOverdueCase();
    } else if (this.$route.query.type == "repay") {
      this.getRemindCase();
    }
    this.getPaymentRecordTableList();
    this.pageType = this.$route.query.type || "";
  }
  private handleClick(tab: any, event: any) {
    if (tab.name === "second") {
      this.getCaseLogList(this.pageIndex, this.pageSize);
    } else if (tab.name === "fourth") {
      this.getAutoCallResult(this.pageIndex, this.pageSize);
    } else if (tab.name === "fifth") {
      this.getRobotCallRecord(this.pageIndex, this.pageSize);
    }
  }
  @Watch("$route")
  onRouteChanged(val: any) {
  }

  private autoDialNextOver() {
    (this.$refs.autoDialNextFun as automatiCall).autoDialNext();
  }
  // 获取机器人拨打记录
  private async getRobotCallRecord(pageIndex: any, pageSize: any) {
    const {
      setRobotCallOutRecordListParamsReq,
      getRobotCallOutRecordRequest,
    }: any = await import("@/request/getRobotCallOutRecord");
    let data = await getRobotCallOutRecordRequest.handleHttp(
      setRobotCallOutRecordListParamsReq({
        OrderId: "" + this.$route.query.orderId,
        Page: {
          pageIndex: pageIndex ? pageIndex : this.pageIndex,
          pageSize: pageSize ? pageSize : this.pageSize,
        },
      }),
      this
    );
    this.dwRobotCallRecord(data);
  }
  // 回款记录
  private async getPaymentRecordTableList() {
    const params = {
      OrderId: this.$route.query.orderId,
    };
    const { getPaymentRecord }: any = await import(
      "@/request/getPaymentRecord"
    );
    let res = await getPaymentRecord(params, this);
    if (res && res.listList) {
      this.paymentRecordList = res.listList.map((item: any, index: number) => {
        const temp = {
          jsIndex: index + 1,
          repaytime: item.repaytime && timeFormat(item.repaytime),
          ctime: item.ctime && timeFormat(item.ctime),
          notifytime: item.notifytime && timeFormat(item.notifytime),
        };
        return Object.assign({}, item, temp);
      });
    }
  }

  private dwRobotCallRecord(res: any) {
    this.activeName = "fifth";
    if (res.listList) {
      let _res = res.listList;
      _res.forEach((element: any) => {
        element.unconnectreason =
          element.isdial == 1 ? "--" : element.unconnectreason;
        element.suggest = element.suggest ? element.suggest : "--";
        element.calltags = element.calltags ? element.calltags : "--";
        element.calltime = timeFormat(element.calltime);
        element.isdial =
          +element.isdial == 1 ? this.$t("v0707.Yes") : this.$t("v0707.No");
      });
      this.robotcalloutrecorditemList = _res;
    }
    if (res.pageout) {
      this.changePageCount = res.pageout.total;
    }
  }

  // 获取overdue工单详情
  private async getOverdueCase() {
    const { setGetOverdueCaseReq, getOverdueCaseRequest }: any = await import(
      "@/request/getOverdueCase"
    );
    let data = await getOverdueCaseRequest.handleHttp(
      setGetOverdueCaseReq({
        caseId: Number(this.$route.query.id),
      }),
      this
    );
    this.dwOverdueCase(data);
  }
  private dwOverdueCase(data: any) {
    data = data?.urgebase;
    this.urgebase = data;
    this.activeName = "first";
    this.mobileNum = data.accountbase.mobile;
    this.caseId = data.ticketdata.relatedid;
    this.itemId = data.ticketdata.itemid;
    this.orderId = data.ticketdata.orderid;
    this.suppliertypeList = data.suppliertypeList;
    this.dwRepayplan(data);
  }

  // 获取催收情况列表
  private async getAutoCallResult(pageIndex: number, pageSize: number) {
    let _arg: Options = {
      Page: {
        pageIndex: pageIndex ? pageIndex : this.pageIndex,
        pageSize: pageSize ? pageSize : this.pageSize,
      },
      mobile: this.mobileNum,
    };
    const {
      getAllAutoCallResult,
      setGetAllAutoCallResultReq,
    }: any = await import("@/request/getAllAutoCallResult");
    let res = await getAllAutoCallResult.handleHttp(
      setGetAllAutoCallResultReq(_arg),
      this
    );
    if (res.listList) {
      let _res = this.dwTime(res.listList);
      this.autoCallData = _res;
    }
    if (res.pageout) {
      this.changePageCount = res.pageout.total;
    }
    this.autoCallData.forEach((element: any) => {
      this.isdial = element.result.duration
        ? this.$t("v0707.Yes")
        : this.$t("v0707.No");
      this.$set(element.result, "isdial", this.isdial);
    });
  }
  // tab页 催收情况
  private async getCaseLogList(pageIndex: number, pageSize: number) {
    let _arg: CaseLogOptions = {
      Page: {
        pageIndex: pageIndex ? pageIndex : this.pageIndex,
        pageSize: pageSize ? pageSize : this.pageSize,
      },
      caseid: this.caseId,
      itemid: this.itemId,
      orderid: this.orderId,
    };
    const { getCaseLogDetail, setGetCaseLogDetailReq }: any = await import(
      "@/request/getAllAutoCallResult"
    );
    let res = await getCaseLogDetail.handleHttp(setGetCaseLogDetailReq(_arg));
    if (res.listList) {
      let _res = this.dwTime(res.listList);
      this.tableData = this.getCaseLogListFun(_res);
    }
    if (res.pageout) {
      this.pagerCount = res.pageout.total;
    }
  }
  private getCaseLogListFun(data: any) {
    data.map((item: any) => {
      // dial拨打方式：0-手动，1-自动
      item.dialway =
        item.dialway == 1
          ? this.$tc("tableLgy.AutoCall")
          : this.$tc("tableLgy.ManualCall");
    });
    return data;
  }
  private dwTime(data: any) {
    data.forEach(function(item: any) {
      if (Object.prototype.toString.call(item.result) === "[object Object]") {
        item = item.result;
      }
      for (let key in item) {
        if (
          typeof item["" + key + ""] == "number" &&
          ("" + item["" + key + ""]).length == 13
        ) {
          item["" + key + ""] = timeFormat(item["" + key + ""]);
        }
      }
    });
    return data;
  }
  private refreshTable(pageIndex: number, pageSize: number) {
    this.getCaseLogList(pageIndex, pageSize);
  }
  private autoCallTable(pageIndex: number, pageSize: number) {
    if (this.activeName == "fifth") {
      this.getRobotCallRecord(pageIndex, pageSize);
    } else {
      this.getAutoCallResult(pageIndex, pageSize);
    }
  }
  // 获取还款提醒的详情
  private async getRemindCase() {
    const { setGetRemindCaseReq, getRemindCaseRequest }: any = await import(
      "@/request/getRemindCase"
    );
    let data = await getRemindCaseRequest.handleHttp(
      setGetRemindCaseReq({
        caseId: Number(this.$route.query.id),
      }),
      this
    );

    this.dwRemindCase(data);
  }
  private dwRemindCase(data: any) {
    data = data.urgebase;
    this.urgebase = data;
    this.activeName = "first";
    this.mobileNum = data.accountbase.mobile;
    this.caseId = data.ticketdata.relatedid;
    this.itemId = data.ticketdata.itemid;
    this.orderId = data.ticketdata.orderid;
    this.dwRepayplan(data);
  }
  // 处理还款计划数据
  private dwRepayplan(data: any) {
    if (this.multi_loan_switch) {
      // 多订单
      data.repayplanstagetablistList.forEach((item: any, index: any) => {
        if (item.repayplanstageList) {
          item.repayplanstageList.forEach((n: any) => {
            n.repaydate = n.repaydate && timeFormat(n.repaydate);
            n.cleartime = n.cleartime ? timeFormat(n.cleartime) : "-";
            if (n.extrafiled) {
              n.group =
                JSON.parse(n.extrafiled) && JSON.parse(n.extrafiled).Group;
            }
            return n;
          });
        }
      });
      this.repayplanstagetablistList = data.repayplanstagetablistList;
    } else {
      // 单期还款计划
      if (data.repayplan && data.repayplan.repaydate) {
        this.repaymentPlanData = data.repayplan;
        this.repaymentPlanData.repaydate =
          this.repaymentPlanData.repaydate &&
          timeFormat(this.repaymentPlanData.repaydate);
        if (data.repayplan.extrafiled) {
          this.repaymentPlanData.group =
            JSON.parse(data.repayplan.extrafiled) &&
            JSON.parse(data.repayplan.extrafiled).group;
        }
      }
      // 分期还款计划
      if (data.repayplanstageList) {
        this.repayplanstageList = data.repayplanstageList;
        this.repayplanstageList.forEach((item: any) => {
          item.repaydate = item.repaydate && timeFormat(item.repaydate);
          item.cleartime = item.cleartime ? timeFormat(item.cleartime) : "-";
          if (item.extrafiled) {
            item.group =
              JSON.parse(item.extrafiled) && JSON.parse(item.extrafiled).Group;
          }
          return item;
        });
      }
    }
  }
  // 处理公共部分
  private dwCommonFuc(data: any) {}
  // 获取子组件传递数据
  private getTableData(flg: boolean) {
    if (flg) {
      if (this.$route.query.type == "overdue") {
        this.getOverdueCase();
      } else if (this.$route.query.type == "repay") {
        this.getRemindCase();
      }
    }
  }
}
